import { useEffect, useState } from 'react';

/**
 * Si el usuario pidió menos movimiento en su sistema operativo.
 *
 * El tablero tiene un presupuesto de animación corto pero real —pulso de los
 * esqueletos, entrada escalonada de tarjetas, crecimiento de barras, count-up del
 * KPI— y todo eso se anula aquí. Media docena de bloques latiendo a la vez es
 * justo el patrón que dispara molestias vestibulares.
 *
 * Se lee por JS y no sólo por CSS porque varias de esas animaciones no son
 * declarativas: un count-up es un `setInterval`, no una `@keyframes`.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const query = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(query.matches);

    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);

    // Safari < 14 no tiene addEventListener sobre MediaQueryList.
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', onChange);
      return () => query.removeEventListener('change', onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return reduced;
}
